import { NgModule } from '@angular/core';
import { PaymentConfirmationComponent } from './features/checkout/payment-confirmation/payment-confirmation.component';
import { RouterModule } from '@angular/router';
import { ErrorPageComponent } from './contentful/error-page/error-page.component';
import { EmporixCheckoutPaymentConfirmationGuard } from 'haba-emporix';
import { HomepageComponent } from './contentful/homepage/homepage.component';
import { homepageUrl, orderCancellationUrl } from './helper';
import { orderCancellationListGuard } from './features/order-cancellation/order-cancellation-list/order-cancellation-list.guard';
import { orderCancellationSuccessGuard } from './features/order-cancellation/order-cancellation-success/order-cancellation-success.guard';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: 's',
          redirectTo: homepageUrl,
          pathMatch: 'full',
        },
        {
          path: homepageUrl,
          component: HomepageComponent,
        },
        {
          path: 'search',
          loadChildren: () => import('./features/search/search.module').then((m) => m.SearchModule),
        },
        {
          path: 'c',
          redirectTo: 'c/',
          pathMatch: 'full',
        },
        {
          path: 'c',
          loadChildren: () =>
            import('./features/search/category.module').then((m) => m.CategoryModule),
        },
        {
          path: 'wishlist',
          loadChildren: () =>
            import('./features/wishlist/wishlist-custom.module').then(
              (m) => m.WishlistCustomModule
            ),
        },
        {
          path: 'styleguide',
          loadChildren: () =>
            import('./@styleguide/styleguide.module').then((m) => m.StyleguideModule),
        },
        {
          path: 'checkout/payment-confirmation',
          canActivate: [EmporixCheckoutPaymentConfirmationGuard],
          component: PaymentConfirmationComponent,
        },
        {
          path: 'not-available',
          component: ErrorPageComponent,
        },
        {
          path: 'newsletter',
          loadChildren: () =>
            import('./features/newsletter/newsletter.module').then((m) => m.NewsletterModule),
        },
        {
          path: 'cookies',
          loadComponent: () =>
            import('./features/cookie-info/cookie-info.component').then(
              (c) => c.CookieInfoComponent
            ),
        },
        {
          matcher: (segments) => {
            const path = segments.map((s) => s.path).join('/');
            return path === 's/service-vorteile/retoure' || path === 's/service-benefits/returns'
              ? { consumed: segments }
              : null;
          },
          loadComponent: () =>
            import('./features/returns/returns.component').then((c) => c.ReturnsComponent),
        },
        {
          path: orderCancellationUrl.slice(1),
          loadComponent: () =>
            import('./features/order-cancellation/order-cancellation-form/order-cancellation-form.component').then(
              (c) => c.OrderCancellationFormComponent
            ),
        },
        {
          path: orderCancellationUrl.slice(1) + '/list',
          canActivate: [orderCancellationListGuard],
          loadComponent: () =>
            import(
              './features/order-cancellation/order-cancellation-list/order-cancellation-list.component'
            ).then((c) => c.OrderCancellationListComponent),
        },
        {
          path: orderCancellationUrl.slice(1) + '/success',
          canActivate: [orderCancellationSuccessGuard],
          loadComponent: () =>
            import(
              './features/order-cancellation/order-cancellation-success/order-cancellation-success.component'
            ).then((c) => c.OrderCancellationSuccessComponent),
        },
      ],
      {
        anchorScrolling: 'disabled',
        initialNavigation: 'enabledBlocking',
        scrollPositionRestoration: 'enabled',
        onSameUrlNavigation: 'reload',
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
